var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_682_11399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.641 18.9493L14.5116 2.33069C14.0078 1.41358 13.0454 0.84375 12 0.84375C10.9547 0.84375 9.99221 1.41351 9.48835 2.33069L0.359008 18.9493C-0.691873 20.8622 0.690192 23.2031 2.87064 23.2031H21.1294C23.3098 23.2031 24.6919 20.8622 23.641 18.9493Z",
    fill: "#FF6F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28163 8.31873C6.28163 8.26444 6.28316 8.21046 6.28369 8.15625L0.358294 18.9534C-0.690497 20.8645 0.688819 23.2031 2.86493 23.2031H15.6094C10.0899 20.5346 6.28163 14.8724 6.28163 8.31873Z",
    fill: "#FC5C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0027 17.7208L13.1834 7.07879C12.6702 6.1404 11.3298 6.1404 10.8166 7.07879L4.99728 17.7208C4.50212 18.6263 5.15336 19.7344 6.18065 19.7344H17.8193C18.8466 19.7344 19.4979 18.6263 19.0027 17.7208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6094 17.3672C12.6094 17.6907 12.3366 17.9531 12 17.9531C11.6634 17.9531 11.3906 17.6908 11.3906 17.3672C11.3906 17.0436 11.6634 16.7812 12 16.7812C12.3365 16.7812 12.6094 17.0436 12.6094 17.3672Z",
    fill: "#423E4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0083 16.0633C11.6912 16.0633 11.4341 15.8062 11.4341 15.4891V10.5245C11.4341 10.2074 11.6912 9.95032 12.0083 9.95032C12.3253 9.95032 12.5824 10.2074 12.5824 10.5245V15.4891C12.5824 15.8062 12.3253 16.0633 12.0083 16.0633Z",
    fill: "#423E4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2218 13.6875L4.99817 17.7247C4.5004 18.6285 5.15508 19.7344 6.18779 19.7344H10.9219C9.28378 18.028 8.00931 15.971 7.2218 13.6875Z",
    fill: "#E0E0E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_682_11399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlert);
export default __webpack_public_path__ + "static/media/warning-alert.b39051f3baccc7b721f1d1df56789015.svg";
export { ForwardRef as ReactComponent };